export default "/images/ic_packaging.svg?8e2cea3c6750d4dd8295be1e4f5af062";